import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import liff from '@line/liff'
import Loading from 'src/components/layouts/Loading'
import StandardizedButton from 'src/components/common/StandardizedButton'
import { NEW_USER_PATHS } from 'src/routes/newUser'

import BGCommon from 'src/assets/img/register/bg-common.png'

export const LoginLinePage = () => {
  const [showFallback, setShowFallback] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFallback(true)
    }, 2000)

    return () => clearTimeout(timer)
  }, [])

  const handleLineRetry = () => {
    setErrorMessage('')
    setLoading(true)
    try {
      if (!liff || typeof liff.isLoggedIn !== 'function') {
        setErrorMessage('LINEログインの初期化に失敗しました。時間をおいて再度お試しください。')
        setLoading(false)
        return
      }
      if (liff.isLoggedIn()) {
        window.location.reload()
      } else {
        liff.login()
      }
    } catch (e) {
      console.error('Line login retry failed:', e)
      setErrorMessage('LINEログイン処理中にエラーが発生しました。再度お試しください。')
      setLoading(false)
    }
  }

  const handleEmailLogin = () => {
    navigate(NEW_USER_PATHS.LoginPage)
  }

  return (
    <Wrapper>
      {!showFallback ? (
        <Loading />
      ) : (
        <div className="absolute inset-0 flex flex-col justify-center items-center px-6 bg-black/50 backdrop-blur-sm text-center">
          <div className="bg-white/95 backdrop-blur-md rounded-2xl p-6 w-full max-w-[340px] shadow-2xl border border-white/50 flex flex-col items-center">
            <h3 className="text-lg font-bold text-gray-800 mb-3">ログイン</h3>
            <p className="text-sm text-gray-600 mb-5 leading-relaxed font-light">
              セッションの有効期限が切れたか、自動ログインが完了していません。<br />
              下のボタンを押してLINEでログインしてください。
            </p>

            {errorMessage && (
              <p className="text-xs text-red-500 mb-3 px-2 font-medium">
                {errorMessage}
              </p>
            )}

            <StandardizedButton
              className="w-[200px] h-[48px] mb-3"
              onClick={handleLineRetry}
              disabled={loading}
              title={loading ? '処理中...' : 'LINEでログイン'}
            />

            <button
              type="button"
              onClick={handleEmailLogin}
              className="text-xs text-slate-500 underline mt-2 hover:text-slate-700 transition-colors"
            >
              メールアドレスでログイン
            </button>
          </div>
        </div>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div.attrs({
  className: 'sm:w-[400px] w-screen h-screen mx-auto relative bg-center bg-cover bg-no-repeat'
})`
  background-image: url('${BGCommon}');
`
